import type { RecipientRelationship } from "@a2/core";

/**
 * Static minimum-word floor for the runner's requirements footer + word meter.
 * 40 is the DUO A2 e-mail floor. There is no per-variant `minWords` field in
 * the data model — this is a hard-coded constant, not a fake API value.
 */
export const SCHRIJVEN_MIN_WORDS = 40;

/**
 * Derive a human-readable register label from the recipient relationship that
 * drives the grader's u/je check. Returns null when there is no recipient
 * (form / wijkkrant) — caller omits the Register cell.
 *
 * The two label strings are resolved by the caller via i18n
 * (`schrijven.runner.registerFormal` / `registerInformal`).
 */
export function registerToneFor(
  relationship: RecipientRelationship | null,
): "formal" | "informal" | null {
  if (relationship === null) return null;
  return relationship === "authority" ? "formal" : "informal";
}
